import React, {Component} from 'react';
import {BrowserRouter as Router, Route} from 'react-router-dom';

import Home from './components/pages/Home';
import Projects from './components/pages/Projects';
import HomeHeader from './components/layouts/HomeHeader';
import Skills from './components/pages/Skills';
import Employment from './components/pages/Employment';
import Contact from './components/pages/Contact';

import './App.css';

class App extends Component {
	state = {
		degree: {
			line1: 'Bachelor of Science,',
			line2: 'Computer Science',
			line3: '& Software Engineering',
			uni: 'University of Washington Bothell ',
			graduated: 'March 2016' 
		},
		projects: {
			title: 'Projects',
			sites: [ 
				{name: 'Harley Road Tour'},
				{name: 'Amazon Career Choice'},
				{name: 'Firenze', url: 'https://www.firenzeworld.com/'},
				{name: 'Chargespot', url: 'http://www.chargespot.com.mx/'},
				{name: 'MEIC', url: 'http://sitio.meic.com.mx/'},
				{name: 'act. Studio', url: 'http://actstudio.mx/'}
			],
			video: 'web-looppress.mp4',
			text: "Working closely with designers, back-end engineers and clients in order to bring to life clients' consumer-facing websites. Each site is custom designed, fully responsive, user friendly, as well as mobile friendly. Each site is developed to design specification with the client message and target in mind. All projects are worked until the client is satisfied with the results."
		},
		skills: {
			title: 'Skills',
			tech:['HTML', 'CSS', 'JavaScript', 'SCSS', 'React', 'Vue', 'JQuery', 'Bootstrap',
			'Materialize', ' Foundation', 'NPM', 'PHP', 'C++', 'Java', 'CakePHP', 
			'Data structures', 'Scrum', 'Agile']
		},
		employment: {
			title:'Employment',
			jobs: [
				{
					title: 'Front-End Engineer',
					company: 'Fiduciary Tech',
					dates: 'Nov. 2018 - Present',
					description: [
						'- Developed the UI of the project used by their employees all over the world.',
						'- Aided in the redesign to be implemented in the project for mobile and desktop views.',
						'- Gathered requirements based on client’s needs and requirements.',
						'- Presented data from various countries to thousands of users in ways that are easy to comprehend and navigate.'
					]
				},
				{
					title: 'Front-End Consultant',
					company: 'Freelance',
					dates: 'Feb. 2018 — Present',
					description: [
						'- Built new features or interfaces that meet the client’s needs and requirements.',
						'- Called upon to fix UI features which didn’t accurately match high quality UI designs.',
						'- Improved the existing UI to the end user including look, feel, and behavior.',
						'- Worked with the client’s development team to find solutions or improvements to their current UI.'
					]
				},
				{
					title: 'Senior Front-End Engineer',
					company: 'act. Studio',
					dates: 'Jun. 2015 - Nov. 2018',
					description: [
						'- Translated designs into responsive web interfaces which serve as the client’s main website.',
						'- Collaborated with the Chief Designer to create clean interfaces with simple, intuitive interactions and experiences.',
						'- Performed cross-platform cross-browser development.',
						'- Worked in a scrum style fast paced environment with multiple projects and deadlines.',
						'- Carried out quality assurance tests to discover errors and find new ways to improve UI.',
						'- Optimized websites/apps usability for easier navigation and readability.'
					]
				}
			]
		},
		contact: {
			title: 'Contact',
			phone: {
				title: 'Phone:',
				number: '(206) 387 - 8319'
			},
			email: {
				title:'Email:',
				email: 'a.alfaro224@gmail.com'
			},
			linkedin:{
				title:'LinkedIn',
				url: 'https://www.linkedin.com/in/alejandro-alfaro-80bb0772/'
			},
			pdf: {
				title:'resumePDF',
				name: 'Alejandro_Alfaro_Resume.pdf'
			}
		}

	}

	

	render() {
		return (
			<Router>
				<HomeHeader />
				<Route exact path='/' 
					component={() =>
						<Home degree={this.state.degree} />
				} />
				<Route path='/projects'
					component={() =>
						<Projects projects={this.state.projects} />
				} />
				<Route path='/skills'
					component={() =>
						<Skills skills={this.state.skills} />
				}/>
				<Route path='/employment'
					component= {() =>
						<Employment employment={this.state.employment} />
				}/>

				<Route path='/contact'
					component={() => 
						<Contact contact={this.state.contact} />
				}/>
				
			</Router>
		)
	}

}

export default App;